// 污染物管理
<template>
  <div class="mapwrap" v-if="isRefresh">
    <div class="searchInput">
      <el-button class="btnRefresh" type="primary" size="mini" icon="el-icon-refresh-right" @click="handleRefresh">刷新</el-button>
      <el-input v-model="sCN" size="mini" type="search" placeholder="请输入公司名称" clearable @change="getTableData()">
        <template class="searchInput-prepend" slot="prepend">公司名称</template>
        <el-button slot="append" icon="el-icon-arrow-right" @click="getTableData()"></el-button>
      </el-input>
      <el-button v-if="subType === 'enStDataMng'" class="btnUpdate" type="primary" size="mini" icon="el-icon-upload2" @click="uploadTable">导入数据</el-button>
      <el-button v-if="subType === 'enStDataMng'" class="btnUpdate" type="primary" size="mini" icon="el-icon-download" @click="downloadTable">下载模板</el-button>
    </div>
    <div class="mainTable">
      <table class="listTable" width="100%" border="1" align="center">
        <tr>
          <th class="cell thtitle" width="4%">序号</th>
          <th class="cell thtitle" v-if="labels['t11'][0]">{{labels['t11'][0]}}</th>
          <th class="cell thtitle" v-if="labels['t11'][1]">{{labels['t11'][1]}}</th>
          <th class="cell thtitle" v-if="labels['t11'][2]">{{labels['t11'][2]}}</th>
          <th class="cell thtitle" v-if="labels['t11'][3]">{{labels['t11'][3]}}</th>
          <th class="cell thtitle" width="12%" v-if="subType==='enStDataMng'">操作</th>
        </tr>
        <tr v-for="(item, index) in tableData" :key="index">
          <td class="cell tdcell">{{index+1}}</td>
          <td class="cell tdcell" v-if="labels['t11'][0]">
            <el-input v-if="item.editFlag" v-model="item.cpnName"></el-input>
            <span v-else>{{item.cpnName}}</span>
          </td>
          <td class="cell tdcell" v-if="labels['t11'][1]">
            <el-input v-if="item.editFlag" v-model="item.prjName"></el-input>
            <span v-else>{{item.prjName}}</span>
          </td>
          <td class="cell tdcell" v-if="labels['t11'][2]">
            <el-input v-if="item.editFlag" v-model="item.prjType"></el-input>
            <span v-else>{{item.prjType}}</span>
          </td>
          <td class="cell tdcell" v-if="labels['t11'][3]">
            <el-input v-if="item.editFlag" v-model="item.fileType"></el-input>
            <span v-else>{{item.fileType}}</span>
          </td>
          <td class="cell tdcell" v-if="subType==='enStDataMng'">
            <el-button type="text" size="mini" @click="editRow(item)">编辑</el-button>
            <el-button type="text" size="mini" @click="saveRow(item)">保存</el-button>
            <el-button type="text" size="mini" @click="deleteRow(item)">删除</el-button>
          </td>
        </tr>
      </table>
    </div>
    <div class="bottom-pagination">
      <el-pagination
        hide-on-single-page
        small
        background
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :page-size="pages"
        :current-page="pageNo"
        :total="totalNumber">
      </el-pagination>
    </div>
    <el-dialog
      append-to-body
      center
      width="40%"
      v-if="importFlag"
      :visible.sync="importFlag"
      :title="'导入环保职员数据'">
      <ehsTableImport
        ref="uploadRef"
        :btnName="'导入'"
        :uploadMethod="'hbManagementInformationImport'"
        :acceptList="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf'"
        :extaParam="extaParam"
        :fileSize="100"
        @uploadSuccess="handleSuccess"
        @beforeUpload="checkUpload">
      </ehsTableImport>
    </el-dialog>
    <nut-dialog
      @close="importFlag = false"
      v-if="importFlag"
      :visible="importFlag"
      title="'导入环保职员数据'"
      :noFooter="true">
      <ehsTableImport
        ref="uploadRef"
        :btnName="'导入'"
        :uploadMethod="'hbManagementInformationImport'"
        :acceptList="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf'"
        :extaParam="extaParam"
        :fileSize="100"
        @uploadSuccess="handleSuccess"
        @beforeUpload="checkUpload">
      </ehsTableImport>
    </nut-dialog>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import api from '../../../api/index'
// import { ipcRenderer } from 'electron'
import ehsTableImport from '../ehs-com/ehsTableImport'
export default {
  props: ['subType'],
  data () {
    return {
      pollutionSrcsTabType: '11',
      // showTabs: false,
      sCN: '',
      importFlag: false,
      importFlagA: false,
      extaParam: {},
      tableData: [{
        id: 0,
        cpnName: '',
        prjName: '',
        prjType: '',
        fileType: '',
        fileUnit: '',
        fileFileFileName: '',
        fileFileFileSrc: '',
        apprvDpmt: '',
        apprvTime: '',
        apprvNo: '',
        apprvFileFileName: '',
        apprvFileFileSrc: '',
        invstTtl: '',
        invstEnv: '',
        accptTime: '',
        accptCclsn: ''
      }],
      rowItems: ['id', 'cpnName',
        'prjName', 'prjType', 'fileType', 'fileUnit', 'fileFileFileName', 'fileFileFileSrc',
        'apprvDpmt', 'apprvTime', 'apprvNo', 'apprvFileFileName', 'apprvFileFileSrc',
        'invstTtl', 'invstEnv', 'accptTime', 'accptCclsn'],
      labels: {
        t11: [ // 环境监察
          '公司名称', // 0
          '姓名', '联系电话', '负责内容', '', '', // 1-5
          '', '', '', '', // 6-9
          '', '', '', '' // 10-13
        ]
      },
      pages: 10,
      pageNo: 1,
      totalNumber: 1,
      isRefresh: true
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getTableData (pageNo = 1) {
      var enquiryPusher = {
        pages: this.pages,
        pageNo: pageNo
      }
      if (this.sCN) {
        enquiryPusher.cpnName = this.sCN
      }
      enquiryPusher.category = this.pollutionSrcsTabType
      console.log('getTableData: pageNumber=' + this.pageNo + ', category=' + this.pollutionSrcsTabType)
      api.hbManagementInformationEnquiry(enquiryPusher).then(res => {
        console.log(res)
        this.totalNumber = res.data.totalNumber
        var tempArr = []
        res.data.list.forEach(item => {
          var arrPusher = {}
          for (var i = 0; i < this.rowItems.length; i++) {
            if (this.rowItems[i] in item) {
              // console.log(this.rowItems[i])
              arrPusher[this.rowItems[i]] = item[this.rowItems[i]]
            }
          }
          arrPusher.editFlag = false
          tempArr.push(arrPusher)
        })
        this.tableData = tempArr
      })
    },
    handleRefresh () {
      console.log('refresh')
      this.isRefresh = false
      this.$nextTick(function () {
        this.isRefresh = true
        this.pageNo = 1
        this.getTableData()
      })
    },
    table_index (index) {
      return (this.pageNo - 1) * this.pages + index + 1
    },
    handleCurrentChange (pageNo) {
      this.pageNo = pageNo
      this.getTableData(this.pageNo)
    },
    editRow (row) {
      row.editFlag = true
    },
    saveRow (row) {
      row.editFlag = false
      var savePusher = {}
      for (var i = 0; i < this.rowItems.length; i++) {
        if (this.rowItems[i] in row) {
          // console.log(this.rowItems[i])
          savePusher[this.rowItems[i]] = row[this.rowItems[i]]
        }
      }
      api.hbManagementInformationUpdate(savePusher).then(res => {
        console.log(res)
      })
    },
    deleteRow (row) {
      api.hbManagementInformationDelete({ id: row.id }).then(res => {
        console.log(res)
        this.getTableData()
      })
    },
    downloadTable () {
      var link = 'http://hbxz.qsyhbgj.com/admin/公司环保职员模板.xlsx'
      console.log(link)
      window.open(link)
      // var dPusher = {}
      // dPusher.category = Number(this.pollutionSrcsTabType)
      // api.hbManagementInformationDownload(dPusher).then(res => {
      //   console.log(res)
      //   // ipcRenderer.send('ipcDownloadBegin', res.name)
      // })
    },
    uploadTable () {
      this.importFlag = true
      this.extaParam = { category: this.pollutionSrcsTabType }
    },
    checkUpload () {
      this.$refs.uploadRef.doUpload()
    },
    checkUploadA () {
      this.$refs.uploadRefA.doUpload()
    },
    handleSuccess () {
      this.$toast.text('上传成功')
      this.importFlag = false
      this.importFlagA = false
      this.getTableData()
    }
  },
  components: {
    ehsTableImport
    // api,
    // showTableData () {
    //   return this.tableData
    // }
  }
}
</script>

<style lang="scss">
.homepage{
  width: 100%;
  div{
    border-radius: 2px;
  }
}
.mapwrap{
  z-index: 0;
  height: 100%;
  overflow: hidden;
}
.pollutionSrcsTabs{
  margin: 0 10px;
}
.searchInput{
  width: 50%;
  margin: 4px 10px;
  // padding-left: 10px;
  display: flex;
  font-size: 16px;
  .searchInput-prepend{
    font-weight: bold;
  }
  // margin-top: 0;
  // .searchInput div{
  //   height: 40px;
  //   // line-height: 40px;
  // }
  // .searchLabel{
  //   padding-top: 1px;
  //   height: 32px;
  //   font-size: 17px;
  // }
  // .el-input__icon{
  //   width: 20px!important;
  //   line-height: 28px!important;
  // }
}
.btnRefresh{
  margin: 0 10px 0 0!important;
}
.btnUpdate{
  margin: 0 0 0 10px!important;
  width: 120px!important;
}
.mainTable{
  margin: 10px;
  width: calc(100% - 20px);
  .tableFileCell{
    text-decoration: underline;
    color: #00C;
  }
  .tableFileCell:hover{
    color: #66F;
    text-decoration: none;
  }
}
.bottom-pagination .el-pagination {
  text-align: right;
  margin-top: 6px;
  margin-bottom: 6px;
}

.el-card{
  margin-top: 4px;
  .el-card__header{
    padding: 0;
  }
  .el-card__body{
    padding: 0;
    overflow-y: auto;
  }
}
</style>
